@if (tags) {
  @for (tag of tags; track tag; let isLast = $last) {
    <exl-tag [label]="tag.label ? tag.label : tag"></exl-tag>
    @if (!isLast) {
      <mulo-separator></mulo-separator>
    }
  }
}
@if (!tags) {
  <ng-content></ng-content>
}
